import { v4 } from 'is-uuid';

export default defineNuxtRouteMiddleware((to) => {
  if (to.path.includes('/items') && !v4(to.params.itemId)) {
    return abortNavigation();
  }
});
